import { Injectable } from '@angular/core';
import {
  CreationServicePayloadModel,
  CreationServiceResultModel,
  PackageResponseModel,
  ServiceFiltersModel,
  ServiceResponseModel,
  UpdateServicePayloadModel,
  UpdateServiceResultModel,
} from '@core/models/service.model';
import { ApiService } from '@core/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ServiceService {
  constructor(private readonly apiService: ApiService) {}

  getServices(filter: ServiceFiltersModel): Observable<ServiceResponseModel> {
    return this.apiService.get('/partners/service', filter as any);
  }

  getServicesByLocationId(
    locationId: number,
    limit: number = 10,
    offset: number = 0,
  ): Observable<ServiceResponseModel> {
    const filter: ServiceFiltersModel = { locationId, limit, offset };
    return this.getServices(filter);
  }

  getServicesByPartnerOid(
    partnerOid: string,
    limit: number = 5,
    offset: number = 0,
  ): Observable<ServiceResponseModel> {
    return this.getServices({ partnerOid, limit, offset });
  }

  getPackagesByPartnerOid(
    partnerOid: string,
    limit: number = 10,
    offset: number = 0,
  ): Observable<PackageResponseModel> {
    return this.apiService.get('/partners/servicepackages', { partnerOid, limit, offset } as any);
  }
  createService(
    serviceCreate: CreationServicePayloadModel,
  ): Observable<CreationServiceResultModel> {
    const { partnerOid, ...body } = serviceCreate;
    return this.apiService.post(`/partners/${partnerOid}/service`, body);
  }
  updateService(
    serviceId: number,
    serviceUpdate: UpdateServicePayloadModel,
  ): Observable<UpdateServiceResultModel> {
    return this.apiService.put(`/partners/service/${serviceId}`, serviceUpdate);
  }
  activateService(serviceId: number): Observable<UpdateServiceResultModel> {
    return this.apiService.put(`/partners/service/${serviceId}/activation?enabled=true`);
  }
  deactivateService(serviceId: number, endDate: string): Observable<UpdateServiceResultModel> {
    return this.apiService.put(
      `/partners/service/${serviceId}/activation?enabled=false&endDate=${endDate}`,
    );
  }
}
